/**
 * Errors a screen is already showing in its own words.
 *
 * The query cache toasts "Couldn't load your data" for any read that fails
 * (lib/queryClient.ts), so a page with no error state of its own still tells
 * the truth. A panel that DOES draw a LoadError for its failed query then said
 * it twice: the card in place, and the same failure again in a toast. A
 * LoadError marks the error it shows here when it mounts; the cache waits a
 * moment before toasting and says nothing for an error a panel has taken.
 *
 * A WeakSet of the error objects themselves: React Query hands the panel the
 * very object it passed the cache, and nothing here outlives it.
 */
const shown = new WeakSet<object>();

/** A panel is showing this error (components/ui/load-error.tsx). */
export function markErrorShown(error: unknown): void {
  if (error && typeof error === "object") shown.add(error);
}

/** Whether a panel has shown this error. */
export function errorShownByPanel(error: unknown): boolean {
  return !!error && typeof error === "object" && shown.has(error);
}
